/** @format */

// ブラウザの前ページに戻る機能を無効化する
export const browserBackBan = () => {
  window.history.pushState(null, "", null);
  window.addEventListener("popstate", () => {
    window.history.pushState(null, "", null);
    return;
  });
};
